import SimpleBar from 'simplebar';

const moduleName = 'scrollPanel';

export function scrollPanel () {
    Array.from(document.querySelectorAll('.js-scroll')).forEach((self) => {
        if(!(window.matchMedia('(max-width: 768px)').matches && self.classList.contains('js-mob-scroll-off'))){
            new SimpleBar(self);
        }
    });

    window.SimpleBar = SimpleBar;
}
